import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

export function StatusBox({ type, className, children }) {
  return (
    <div className={classNames(`alert alert-${type} p-2`, className)} role='alert'>
      {children}
    </div>
  );
}

StatusBox.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
}

StatusBox.defaultProps = {
  className: null
}
